import { useState } from 'react'
import { Tab } from 'react-bootstrap';
import EmailUser from "./EmailUser";
import ReactSlider from '@src/common/ReactSlider';


const loginLeft = {
    backgroundImage: `url("/images/Group_1000005712.png")`,
    backgroundColor: "#0B1E51",
    backgroundRepeat: "repeat-y",
    backgroundPosition: "top left",
    borderRadius: "0px"
}


function RegisterMobile() {
    
    // eslint-disable-next-line
    const [showMobileLinks, setShowMobileLinks] = useState(true);
    // eslint-disable-next-line
    const [showEmailLinks, setShowEmailLinks] = useState(true);
    const [isOtpVerifyScreen, setIsOtpVerifyScreen] = useState(false);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="login-outer register-outer register-outer-mobile">
                    <div className="login-left-panel" style={loginLeft}>
                        <ReactSlider screenType="Register"></ReactSlider>
                    </div>
                    {
                        isOtpVerifyScreen && <div className='overlay overlay-mobile'></div>
                    }
                    <div className={isOtpVerifyScreen ? "login-right-panel t-center overlay-otp" : "login-right-panel t-center"}>
                    
                        <div className="login-heading m-md-t">
                            <h2>
                                {
                                 isOtpVerifyScreen ? 
                                 "Verify OTP" :
                                 "Register With Us"
                                }
                            </h2>
                        </div>
                      
                        <Tab.Container id="" defaultActiveKey="first">
                            <div className="login-tab">

                                {/* <Nav variant="pills" className="flex-column" onSelect={() => activeTabHandler()}>
                                    {(showEmailLinks && showMobileLinks) &&

                                        <Nav.Item>
                                            <Nav.Link eventKey="first">By Email</Nav.Link>
                                        </Nav.Item>
                                    }
                                    {(showEmailLinks && showMobileLinks) &&
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">By Mobile</Nav.Link>
                                        </Nav.Item>
                                    }
                                </Nav> */}


                                <Tab.Content>
                                    <Tab.Pane eventKey="first">
                                        <EmailUser setShowEmailLinks = {setShowEmailLinks} setShowMobileLinks = {setShowMobileLinks} setIsOtpVerifyScreen={setIsOtpVerifyScreen} isRegister={true} />

                                    </Tab.Pane>
                                    {/* <Tab.Pane eventKey="second">
                                        <MobileUser setShowEmailLinks = {setShowEmailLinks} setShowMobileLinks = {setShowMobileLinks}  showCaptcha={showCaptcha} />
                                    </Tab.Pane> */}
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RegisterMobile